import React from 'react'
import PropTypes from 'prop-types'
import {
  PlayButton,
  PlayButtonArrow,
  PlayButtonCircle,
  PlayButtonIco,
  PlayButtonPath,
  PlayButtonReplay,
} from './VideoPlayer.style'

const VideoPlayButton = ({ level, replay }) => (
  <PlayButton level={level}>
    <PlayButtonIco xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <PlayButtonArrow show={!replay}>
        <PlayButtonPath d="m16 8-13-7v14z" />
      </PlayButtonArrow>
      <PlayButtonReplay show={replay}>
        <PlayButtonCircle cx="8" cy="8" r="7" />
        <PlayButtonPath d="m4.1.9-5.6 2.9 6 3z" />
      </PlayButtonReplay>
    </PlayButtonIco>
  </PlayButton>
)

VideoPlayButton.propTypes = {
  level: PropTypes.string,
  replay: PropTypes.bool,
}

VideoPlayButton.defaultProps = {
  level: 'primary',
  replay: false,
}

export default VideoPlayButton
